import React, { Fragment } from 'react';
import { Field } from 'redux-form';
import { string, bool } from 'prop-types';
// import { isString } from 'lodash';

import MenuItem from '@material-ui/core/MenuItem';
import { required, validURL } from 'helpers/validate';
import { renderSelectField, renderTextField } from './customFields';

const cmeTypes = [
  ['mention', 'Mention'],
  ['watchlist', 'Watchlist'],
  ['collection', 'Collection'],
  ['tdo', 'Media (Temporal Data Objects)']
];
export default class ContextMenuExtensionForm extends React.Component {
  static propTypes = {
    componentType: string,
    isEditing: bool
  };
  state = {
    selectedType: ''
  };

  handleOnChange = (e, newValue) => {
    this.setState({ selectedType: newValue });
  };

  render() {
    return (
      <Fragment>
        {!this.props.isEditing &&
          <Field
            component={renderSelectField}
            name="contextMenuExtension.type"
            label="Type"
            validate={[required]}
            onChange={this.handleOnChange}
          >
            {cmeTypes.map(cmeType =>
              <MenuItem key={cmeType[0]} value={cmeType[0]}>
                {cmeType[1]}
              </MenuItem>
            )}
          </Field>}
        <Field
          name="contextMenuExtension.label"
          component={renderTextField}
          label="Label"
          validate={[required]}
          style={{ marginTop: '15px' }}
        />
        <Field
          name="contextMenuExtension.url"
          label="Open a URL in a new tab (optional)"
          component={renderTextField}
          type="url"
          placeholder={
            this.state.selectedType &&
            `https://example.com?${this.state.selectedType}Id=$\{${this.state
              .selectedType}Id}`
          }
          validate={[validURL]}
          style={{ marginTop: '15px' }}
        />
        {/* I'm commenting this out until all the rest of VTN-12170 is worked out
        <div style={{ marginTop: '15px' }}>
          <em style={{ fontSize: '0.8em' }}>
            When a user selects this context menu extension, it will trigger{' '}
            {getEventName(this.state.selectedType)} that can be{' '}
            <a
              href="https://api.veritone.com/v3/graphqldocs/subscribeevent.doc.html"
              target="_blank"
            >
              subscribed to
            </a>.
          </em>
        </div>
        */}
      </Fragment>
    );

    /* I'm commenting this out until all the rest of VTN-12170 is worked out
    function getEventName(selectedType) {
      const DEFAULT = 'an event';
      if (!isString(selectedType)) {
        return DEFAULT;
      }
      const capitalizationMap = {
        tdo: 'TDO',
        mention: 'Mention',
        watchlist: 'Watchlist',
        collection: 'Collection'
      };
      let capitalizedObjectName = capitalizationMap[selectedType.toLowerCase()];
      if (!capitalizedObjectName) {
        return DEFAULT;
      }
      return `a ${capitalizedObjectName}CMESelected event`;
    }
*/
  }
}



// WEBPACK FOOTER //
// ./src/client/plugins/applications/components/packageFormFields/ContextMenuExtensionField.js